import { render, staticRenderFns } from "./TableLicenciaAlcoholesBitacora.vue?vue&type=template&id=d0d2d346&"
import script from "./TableLicenciaAlcoholesBitacora.vue?vue&type=script&lang=js&"
export * from "./TableLicenciaAlcoholesBitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports